import Network from '@/services/network'

export default function handleFormFieldCustomization() {
    const network = new Network();

    const getConfig = (companyId, moduleId) => {
        return network.api('get', `/company/form-field-customization?company_id=${companyId}&module_id=${moduleId}`);
    }

    const saveConfig = (companyId, moduleId, routeName, fieldsConfig) => {
        return network.api('post', '/company/form-field-customization', {
            company_id: companyId,
            module_id: moduleId,
            route_name: routeName,
            fields_config: fieldsConfig
        });
    }

    return {
        getConfig,
        saveConfig
    }
}
